
import CalendarKendo from '@/components/Calendar/CalendarKendo.vue';

import swal from 'sweetalert2';
import { ref, onMounted } from 'vue';
import { OrderProduct, Slot } from '@/models/Order';
import router from '@/router';
import { useI18n } from 'vue-i18n';
import mixin from '@/mixin';
import moment from 'moment';
import { generalStore } from '@/store';
import { CustomerToChangeDate } from '@/models/Interfaces';
import { CalendarSlot } from '@/models/Calendar';
import useOrder from '@/modules/useOrder';

export default {
    components: { CalendarKendo },
    async setup() {
        const { t } = useI18n();
        const loaded = ref(false);
        const product = ref(new OrderProduct());
        const priceTypeId = ref('');
        const customerId = '';
        const toChangeDate = ref<CustomerToChangeDate | null>(null);
        const { removemillis, normalizeTimeString } = useOrder();

        function Cancel() {
            router.push({ name: 'neworder' });
        }

        async function SaveNewOrderProductDate(): Promise<boolean> {
            if (toChangeDate.value == null || !generalStore.state.order) {
                return false;
            }
            if (toChangeDate.value.couponId) {
                const coupon = generalStore.state.order?.coupons.find(x => x.id == toChangeDate.value?.couponId);
                if (!coupon) {
                    return false;
                }
                if (
                    moment(product.value.date).isBefore(moment(coupon.validDateFrom)) ||
                    moment(product.value.date).isAfter(moment(coupon.validDateTo))
                ) {
                    swal.fire({
                        icon: 'error',
                        text: t('alert.CouponDateExepted')
                    });
                    return false;
                }
            }

            const productStore = generalStore.state.order.products.find(x => x.productId == toChangeDate.value?.productId);
            if (!productStore) {
                return false;
            }
            const customerStore = productStore.customers.find(
                x => x.id == toChangeDate.value?.customerId && x.date == toChangeDate.value?.date
            );
            if (!customerStore) {
                return false;
            }

            customerStore.date = `${product.value.date}T${normalizeTimeString(product.value.slot.startTime)}`;
            customerStore.slot = product.value.slot;
            customerStore.slotId = product.value.slot.id;
            return true;
        }

        async function onselectslot({ slotId, slot, date }: any) {
            product.value.date = date;
            product.value.slotId = slotId;
            product.value.slot = slot;
            product.value.customers = [];
            const confirm = await SaveNewOrderProductDate();
            if (confirm) {
                const order = generalStore.getters.getNewOrder;
                const isQuote = !!order.crmCustomerLeadId;
                isQuote
                    ? router.push({ name: 'quote-new', params: { crmCustomerLeadId: order.crmCustomerLeadId } })
                    : router.push({ name: 'neworder' });
            }
        }

        function onselectvirtualslot(model: CalendarSlot) {
            const slot: Slot = {
                duration: model.duration,
                endTime: model.endTime,
                id: model.id,
                quantity: 0,
                startTime: model.startTime,
                endTimeView: removemillis(model.endTime),
                startTimeView: removemillis(model.startTime),
                isVirtual: model.isVirtual,
                daysOfWeek: [],
                productId: model.productId,
                startDate: '',
                slotFakeId: model.slotFakeId
            };
            const slotId = slot.id;
            const startDate = model.startDate;
            const ignoreQty = true;
            onselectslot({ slotId, slot, date: startDate, ignoreQty });
        }

        async function onMountedAction() {
            swal.showLoading();
            toChangeDate.value = generalStore.state.customerToChangeDate;
            if (toChangeDate.value == null) {
                router.replace({ name: 'neworder' });
                return;
            }
            product.value.slotId = toChangeDate.value.slot.id;
            product.value.slot = toChangeDate.value.slot;
            product.value.productId = toChangeDate.value.productId;
            product.value.date = toChangeDate.value.date.split('T')[0];
            product.value.calendarDate = mixin.methods.getDateToTitle(toChangeDate.value.date);
            priceTypeId.value = toChangeDate.value.priceTypeId;
            loaded.value = true;
            swal.close();
        }

        onMounted(onMountedAction);

        return { product, priceTypeId, Cancel, onselectslot, customerId, loaded, toChangeDate, onselectvirtualslot };
    }
};
